import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNewspaper1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNewspaper1"><Path d="M12 6.5V19.5M2.5 4.5L12 6L21.5 4.5V18.5L12 20L2.5 18.5V4.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconNewspaper1;
